import { styled } from '@/stitches.config';
import { ReactNode } from 'react';
import {
  ICON_BLOCK_DEFAULT_CLIP_PATH,
  ICON_BLOCK_ON_HOVER_CLIP_PATH,
} from '@/components/icon-overlay/icon-overlay';
import { buttonFocusStyle } from '@/components/button-link/button-link';
import { AccessibleIcon } from '@/components/accessible-icon/accessible-icon';

interface ButtonProps {
  onClick: () => void;
  label: string;
  icon: ReactNode;
}

export function Button({ onClick, label, icon }: ButtonProps) {
  return (
    <StyledButton onClick={onClick}>
      <AccessibleIcon label={label}>{icon}</AccessibleIcon>
      <HoverContent>
        <AccessibleIcon label={label}>{icon}</AccessibleIcon>
      </HoverContent>
    </StyledButton>
  );
}

const IconHoverBlock = styled('span', {
  position: 'absolute',
  bottom: 0,
  left: 0,
  backgroundColor: '$foreground',
  padding: 'calc($1 + 2px)',

  ...ICON_BLOCK_DEFAULT_CLIP_PATH,

  transition: 'clip-path 320ms ease-out',
});

const StyledButton = styled('button', {
  all: 'unset',
  cursor: 'pointer',
  padding: 'calc($1 + 2px)', // keeping the original dimensions
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  position: 'relative',

  '&:hover, &:active': {
    [`${IconHoverBlock}`]: {
      ...ICON_BLOCK_ON_HOVER_CLIP_PATH,
    },
  },

  '&:focus-visible': {
    ...buttonFocusStyle,
    outlineOffset: '-2px',
  },
});

function HoverContent({ children }: { children: ReactNode }) {
  return (
    <IconHoverBlock aria-hidden="true">
      <DuplicateContentBlock>{children}</DuplicateContentBlock>
    </IconHoverBlock>
  );
}

const DuplicateContentBlock = styled('span', {
  position: 'relative',
  display: 'block',
  color: '$background',
});
